import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const mockedPermissions = [
  "standards-list-dashboard",

  "standards-add-internal-controls",
  "standards-view-internal-controls",
  "standards-edit-internal-controls",
  "standards-delete-internal-controls",
  "standards-list-internal-controls",

  "stantards-add-policy",
  "standards-list-policy",
  "standards-view-policy",
  "standards-edit-policy",
  "standards-delete-policy",

  "stantards-add-assets",
  "standards-list-assets",
  "standards-view-assets",
  "standards-edit-assets",
  "standards-delete-assets",

  "standards-add-risks-controls",
  "standards-list-risks-controls",
  "standards-view-risks-controls",
  "standards-edit-risks-controls",

  "standards-delete-risks-controls",
  "standards-add-certificate",
  "standards-list-certificate",
  "standards-view-certificate",
  "standards-edit-certificate",
  "standards-delete-certificate",

  "standards-add-certificate-item",
  "standards-list-certificate-item",
  "standards-view-certificate-item",
  "standards-edit-certificate-item",
  "standards-delete-certificate-item",

  "standards-add-certificate-item-requirement",
  "standards-list-certificate-item-requirement",
  "standards-view-certificate-item-requirement",
  "standards-edit-certificate-item-requirement",
  "standards-delete-certificate-item-requirement",

  "standards-add-audit",
  "standards-view-audit",
  "standards-edit-audit",

  "standards-add-review",
  "standards-view-review",
  "standards-edit-review",

  "standards-add-review-history",
  "standards-view-review-history",
  "standards-edit-review-history",

  "standards-add-review-history-note",
  "standards-view-review-history-note",
  "standards-edit-review-history-note",
];

import appApi from "@/plugins/api/api";
export default new Vuex.Store({
  state: {
    user: null,
    appTile: process.env.VUE_APP_TITLE,
    appModule: process.env.VUE_APP_API_MODULE,
    mainPage: process.env.VUE_APP_MAIN_PAGE,
    moduleName: "",
    goto: null,
    company: null,
    userTextSize: null,
    textSize: 100,
    userContrast: null,
    contrast: 'normal',
    publicContrast: 'normal',
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },

    setStorage(state, response) {
      localStorage.setItem("token", response.access_token);
      localStorage.setItem("user_roles", JSON.stringify(response.roles));
      localStorage.setItem("role", response.roles[0]);
    },
    setGoto(state, goto) {
      if (!goto) {
        sessionStorage.removeItem("goto");
      } else {
        sessionStorage.setItem("goto", goto);
      }
      state.goto = goto;
    },
    setCustomFontSize(state, size) {
      let finalSize = size ? size : 100;
      localStorage.setItem("textSize", finalSize);
      state.textSize = finalSize;
    },
    linkFontSizeToUser(state, linkToUser = "link") {
      switch (linkToUser) {
        case "link":
          state.userTextSize = state.textSize;
          state.user.accessibility
            ? (state.user.accessibility.textSize = state.textSize)
            : (state.user.accessibility = { textSize: state.textSize });
          break;
        case "unlink":
          state.userTextSize = null;
          state.user.accessibility
            ? (state.user.accessibility.textSize = null)
            : (state.user.accessibility = { textSize: null });
          break;
        default:
          break;
      }
    },
    setPublicContrast(state, contrast) {
      let finalContrast = contrast ? contrast : 'normal';
      localStorage.setItem("publicContrast", finalContrast);
      state.publicContrast = finalContrast;
    },
  },
  actions: {},
  getters: {
    getLogo: () => {
      return process.env.VUE_APP_LOGO;
    },
    getModuleName: () => {
      if (process.env.VUE_APP_API_MODULE == "compliance") {
        return "Compliance";
      } else if (process.env.VUE_APP_API_MODULE == "lgpd") {
        return "LGPD";
      }
      return "";
    },

    loadUser: (state) => () => {
      return new Promise((resolve, reject) => {
        appApi
          .postAuthMe()
          .then((res) => {
          
            state.company = {
              ...res.data.data.company,
              modules: res.data.data.modules,
            };
            state.user = res.data.data;

            if(!state.company.modules.includes(process.env.VUE_APP_API_MODULE)) {
              window.location = "/compliance/login";
              return;
            }

            if (state.user.language) {
              localStorage.setItem("userLang", state.user.language);
            }

            if (state.user.accessibility?.textSize) {
              localStorage.setItem(
                "textSize",
                state.user.accessibility.textSize,
              );
              state.userTextSize = state.user.accessibility.textSize;
              state.textSize = state.user.accessibility.textSize;
            } else {
              state.userTextSize = null;
              const localTextSize = localStorage.getItem("textSize");
              if (localTextSize) {
                state.textSize = Number(localTextSize);
              } else {
                localStorage.setItem("textSize", 100);
                state.textSize = 100;
              }
            }

            resolve(state.user);
          })
          .catch((error) => {
            if (
              error &&
              error.response &&
              [401].indexOf(error.response.status) != -1
            ) {
              sessionStorage.setItem("goto", window.location.href);
              window.location = "/compliance/login";
              return;
            }
            reject(error);
          });
      });
    },

    getUser: (state) => () => {
      return new Promise((resolve, reject) => {
        if (state.user) {
          resolve(state.user);
          return;
        }
        reject("user not avaliable");
      });
    },

    getGoto: (state) => () => {
      return new Promise((resolve, reject) => {
        let goto = null;
        if (state.goto) {
          goto = decodeURIComponent(state.goto);
        }
        if (sessionStorage.getItem("goto")) {
          goto = decodeURIComponent(sessionStorage.getItem("goto"));
        }
        if (goto) {
          if (goto.startsWith("/canal-etica")) {
            goto = goto.replace("/canal-etica", "");
          }
          if (goto.startsWith("canal-etica")) {
            goto = goto.replace("canal-etica", "");
          }
          if(!goto || goto.startsWith("standards") || goto.startsWith("/standards")) {
            sessionStorage.removeItem("goto");
            return resolve("");
          }
          if(!goto || goto.startsWith("ombudsman") || goto.startsWith("/ombudsman")) {
            sessionStorage.removeItem("goto");
            return resolve("");
          }
          return resolve(goto);
        }
        return reject(false);
      });
    },

    validateRole: (state) => (role) => {
      if (!state.user.permissions) {
        return false;
      } else if (state.user.permissions.includes(role)) {
        return true;
      }
    },

    hasUserProfiles: (state) => (profilesTest) => {
      if (!state.user) return false;
      for (let i = 0; i < profilesTest.length; i++) {
        if (state.user.profiles.indexOf(profilesTest[i]) != -1) {
          return true;
        }
      }
      return false;
    },

    hasUserProfile: (state) => (profileTest) => {
      if (!state.user) return false;
      for (let i = 0; i < profileTest.length; i++) {
        if (
          state.user.profiles.indexOf(profileTest[i]) != -1 &&
          state.user.profiles.length === 1
        ) {
          return true;
        }
      }
      return false;
    },

    formatDeletedUser: (state) => (name) => {
      if (!name) return "";

      return name.includes("user_deleted") ? i18n.t("comuns.deletedUser") : name;
    },
  },
});
